var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{class:_vm.vrsta,attrs:{"block":_vm.block},on:{"click":function($event){return _vm.pritisak()}}},[(_vm.slika != 'blank')?_c('b-icon',{attrs:{"icon":_vm.slika}}):_vm._e(),_vm._v(" "+_vm._s(_vm.naslov)+" ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }